import { render, staticRenderFns } from "./zCabecalhoWithActions.vue?vue&type=template&id=0b144e10&scoped=true&"
import script from "./zCabecalhoWithActions.vue?vue&type=script&setup=true&lang=js&"
export * from "./zCabecalhoWithActions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b144e10",
  null
  
)

export default component.exports